<template>
  <div class="assessment">
    <NavLogo></NavLogo>

    <hooper
      :progress="true"
      :responsive="true"
      :itemsToShow="1.7"
      :vertical="true"
      :trimWhitespace="true"
      :centerMode="true"
      :pagination="true"
      :shortDrag="false"
      :draggable="false"
      :wheelControl="false"
      :transition="1000"
      ref="carousel"
      v-if="hooperVisible"
    >
      <!-- A. Quiz Questions -->
      <slide v-for="(slide, indx) in slides" :key="indx" :index="indx" class="question-box">
        <mdb-container class>
          <mdb-row class="flex-center">
            <mdb-col md="6">
              <h5>{{indx+1}} / {{slides.length}}</h5>

              <h2>{{ slide.question }}</h2>
              <ul>
                <li v-for="(a,idx) in slide.answers" :key="idx" class="question-box-answer">
                  <label class="labl">
                    <input type="radio" :name="indx" :value="idx" @click="radioClicked(indx,idx)" />
                    <div>
                      <span>{{idx + 1}}</span>
                      {{a}}
                    </div>
                  </label>
                  <!--
                  <input type="radio" :name="indx" :value="idx" @click="radioClicked(indx,idx)" />
                  <label :for="indx">{{a}}</label>-->
                </li>
              </ul>
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>

    <!-- B. Static Part, form questions -->
    <mdb-container v-if="bottomFormVisible" class="form py-5">
      <mdb-row class="flex-center">
        <mdb-col md="8">
          <h3>We would like to get to know you better</h3>
          <p>This information will be used to help customize your learning experience on Exsellance.</p>
          <form @submit.prevent="mthSaveAndFinishAssessment">
            <mdb-row class="mt-5">
              <mdb-col
                md="6"
                v-for="(item,index) in postAssessmentForm"
                :key="'B'+index.toString()"
              >
                <h6>{{item.label}}</h6>
                <input
                  ref="refinput"
                  @keyup="inputKeyup"
                  v-if="item.type=='input'"
                  v-model="item.value"
                  type="text"
                  required
                />
                <select ref="refselect" v-if="item.type=='select'" v-model="item.value" required>
                  <option
                    v-for="(option,index) in item.options"
                    :key="index.toString+option"
                  >{{option}}</option>
                </select>
                <textarea v-if="item.type=='textarea'" v-model="item.value" required />
              </mdb-col>
            </mdb-row>
            <mdb-btn type="submit" color="primary" class="float-right">Finish Quiz</mdb-btn>
          </form>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <mdb-modal :show="modal" @close="modal = false">
      <mdb-modal-header>
        <mdb-modal-title>You have to answer this question</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>Please answer this question</mdb-modal-body>
      <mdb-modal-footer>
        <mdb-btn color="secondary" @click.native="modal = false">OK</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { store } from "../store";
import NavLogo from "../components/NavLogo";
import Footer from "../components/Footer";
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
  Progress as HooperProgress
} from "hooper";
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon,
  mdbModal,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
  mdbModalTitle
} from "mdbvue";
export default {
  name: "assessment",
  data: function() {
    return {
      hooperVisible: true,
      bottomFormVisible: false,
      //debug: true,
      slides: [],
      points: [],
      postAssessmentForm: [
        { label: "Company Name", value: "", type: "input" },
        /*{
          label: "Established since (year)",
          value: "",
          type: "select",
          options: [
            "Not Yet formed",
            "2019",
            "2018",
            "2017",
            "2016",
            "2015",
            "Before 2015"
          ]
        },
        {
          label: "Your role",
          value: "",
          type: "select",
          options: [
            "Founder",
            "Sales Professional",
            "Business Development",
            "Other"
          ]
        },*/
        {
          label: "Industry",
          value: "",
          type: "select",
          options: [
            "Agriculture, mining and utilities",
            "Manufacturing",
            "Construction",
            "Retail",
            "Transportation",
            "Accommodation & food",
            "ICT",
            "Financial and insurance",
            "Real estate activities",
            "Professional and scientific",
            "Administrative & support service",
            "Education",
            "Health and social work",
            "Arts and recreation",
            "Other service activities"
          ]
        },
        {
          label: "Number of employees",
          value: "",
          type: "select",
          options: ["Just me", "1-3", "4-5", "6-10", "11+"]
        },
        /*{
          label:
            "What was it about this platform that attracted you to sign up?",
          value: "",
          type: "textarea"
        },
        {
          label: "Current Revenue (past 12 months)",
          value: "",
          type: "select",
          options: ["Zero", "1 – 500k", "501 – 1m", "1m – 2m", "2m – 5m", "5m+"]
        },
        {
          label: "Target Revenue (next 12 months)",
          value: "",
          type: "select",
          options: [
            "Increase by 5%",
            "Increase by 10%",
            "Increase by 15%",
            "Increase by 20%",
            "Increase by 25%",
            "Increase by 30%",
            "Increase by 35%",
            "Increase by 40%",
            "Increase by 45%+"
          ]
        },
        {
          label: "Current Clients (last 12 months)",
          value: "",
          type: "select",
          options: [
            "Zero",
            "1 – 10",
            "11 – 20",
            "21 – 30",
            "31 – 40",
            "41 – 50",
            "50 – 80",
            "81 – 100",
            "100+"
          ]
        },
        {
          label: "Target Clients (next 12 months)",
          value: "",
          type: "select",
          options: [
            "Increase by 5%",
            "Increase by 10%",
            "Increase by 15%",
            "Increase by 20%",
            "Increase by 25%",
            "Increase by 30%",
            "Increase by 35%",
            "Increase by 40%",
            "Increase by 45%+"
          ]
        },*/
        {
          label: "What are your top three sales challenges today?",
          value: "",
          type: "textarea"
        }
      ],
      sumofpoints: 0,
      //assessmentresults: {}, //will be written to firestore
      modal: false,
      tempchosen: false,
      processSlider: true,
      tempsingleslidepoints: 0,
      questionsref: firebase
        .firestore()
        .collection("assessments")
        .doc("WH9O5Q1P0dGEGcK5LDji")
    };
  },
  created: function() {
    //console.log("questionsref is");
    //store.dispatch('setAssessmentIdParam','asasasas')
    this.mthStatsIncrementStartedAssessments();
    //console.log(this.questionsref);
    this.questionsref.onSnapshot(s => {
      //console.log("snap jest");
      //console.log(s.data().questions); //array of documents references
      this.slides = [];
      var loopstop = s.data().questions.length;
      if (this.debug) loopstop = 3;
      for (var i = 0; i < loopstop; i++) {
        //console.log("loop works");
        //console.log(" questions length is " + s.data().questions.length);
        console.log(
          s
            .data()
            .questions[i].get()
            .then(
              doc => {
                //console.log("then...");
                //console.log(doc.data());
                this.slides.push({
                  question: doc.data().question,
                  answers: doc.data().answers,
                  answerspoints: doc.data().answerspoints,
                  skillname: doc.data().skillname
                });
              },
              error => {
                if (error) console.log(error);
              }
            )
        );
      }
    });
  },
  methods: {
    mthSaveAndFinishAssessment() {
      // this.points.push({ indx: indx, points: this.tempsingleslidepoints });
      // this.sumofpoints += this.tempsingleslidepoints;
      var that = this;
      firebase
        .firestore()
        .collection("usersFilledAssessments")
        .add({
          user: store.getters.getUser.email,
          sumofpoints: this.sumofpoints,
          assessmentscore:
            parseFloat(this.sumofpoints) / parseFloat(this.points.length),
          pointsarr: this.points,
          slides: this.slides,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          postAssessmentForm: this.postAssessmentForm
        })
        .then(function(docRef) {
          //console.log("Document written with ID: ", docRef.id);
          //store.dispatch('setAssessmentIdParam',docRef.id)
          //console.log('thennnnn');
          that.$store.commit("setAssessmentIdParam", docRef.id);
          that.$store.commit("setUserhasfilledhisassessment", true);
          var averagescoreforsingleassessment =
            parseFloat(that.sumofpoints) / parseFloat(that.points.length);
          that.mthStatsIncrementFinishedAssessments(
            averagescoreforsingleassessment
          );
          //that.$router.replace("/skills/" + docRef.id);
          that.$router.replace("/skills");
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    },
    inputKeyup(e) {
      if (e.keyCode === 13) {
        //console.log("enter");
        //console.log(e);
      }
    },
    setFocusOnInput(index) {
      this.$refs["refinput"][index].focus();
    },
    setFocusOnSelect(index) {
      this.$refs["refselect"][index].focus();
    },
    mthStatsIncrementStartedAssessments() {
      let dt = new Date();
      let y = dt.getFullYear().toString();
      let m = (dt.getMonth() + 1).toString();
      //console.log("callin");
      const docref = firebase
        .firestore()
        .collection("statsAssessments")
        .doc(y + "-" + m);
      //exists?
      docref.get().then(snap => {
        if (!snap.exists) {
          const docref = firebase
            .firestore()
            .collection("statsAssessments")
            .doc(y + "-" + m)
            .set({ counter: 1 });
        } else {
          const increment = firebase.firestore.FieldValue.increment(1);
          docref.update({ counter: increment });
        }
      });
    },
    mthStatsIncrementFinishedAssessments(averagescoreforsingleassessment) {
      let dt = new Date();
      let y = dt.getFullYear().toString();
      let m = (dt.getMonth() + 1).toString();
      //console.log("callin");
      const docref = firebase
        .firestore()
        .collection("statsAssessmentsFinished")
        .doc(y + "-" + m);
      //exists?
      docref.get().then(snap => {
        if (!snap.exists) {
          const docref = firebase
            .firestore()
            .collection("statsAssessmentsFinished")
            .doc(y + "-" + m)
            .set({ counter: 1, scoresum: averagescoreforsingleassessment });
        } else {
          const increment = firebase.firestore.FieldValue.increment(1);
          const incrementavgscoresum = firebase.firestore.FieldValue.increment(
            averagescoreforsingleassessment
          );
          docref.update({
            counter: increment,
            scoresum: incrementavgscoresum
          });
        }
      });
    },
    hooperSlide(e) {
      //console.log("hooperslide: ");
      //console.log(e);
    },
    methodBeforeSlide(e) {
      //console.log("ssss");
      //console.log(e);
    },
    updateCarousel(payload) {
      //this.myCarouselData = payload.currentSlide;
      //console.log("update carousel payload is");
      //console.log(payload);
    },
    radioClicked(indx, idx) {
      this.tempchosen = true;
      this.tempsingleslidepoints = this.slides[indx].answerspoints[idx];
      //console.log("chosen: " + indx.toString() + " " + idx.toString());
      //console.log("points: " + this.slides[indx].answerspoints[idx]);
      //console.log("index: " + indx);
      this.points.push({ indx: indx, points: this.tempsingleslidepoints });
      this.sumofpoints += this.tempsingleslidepoints;
      //switch to postassessment form
      if (this.points.length == this.slides.length) {
        //console.log("go to postassessments");
        setTimeout(() => {
          this.processSlider = false;
          this.hooperVisible = false;
          this.bottomFormVisible = true;
        }, 500);
        //console.log(this.points);
      } else {
        if (!this.tempchosen) {
          this.modal = true;
        } else if (this.processSlider) {
          //working
          setTimeout(() => this.$refs.carousel.slideNext(), 500);
          this.tempchosen = false;
        }
      }
    }
  },
  components: {
    NavLogo,
    Footer,
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
    HooperProgress,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    mdbModalTitle
  }
};
</script>

<style scoped>
</style>